var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.75c-2.75 0-4.75-2-4.75-4.75V6.92c0-1.47 1.2-2.67 2.67-2.67h7.17c1.47 0 2.67 1.2 2.67 2.67V12c-.01 2.75-2.01 4.75-4.76 4.75h-3zM7.25 6.92V12c0 1.62 1 3.25 3.25 3.25h3c2.25 0 3.25-1.63 3.25-3.25V6.92c0-.64-.52-1.17-1.17-1.17H8.42c-.64 0-1.17.52-1.17 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5V2c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM13.75 5V2c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM11.25 22v-6c0-.41.34-.75.75-.75s.75.34.75.75v6c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineElectricity);
export default __webpack_public_path__ + "static/media/vuesax-outline-electricity.d26444659893d9630c5a0855e3bf97d7.svg";
export { ForwardRef as ReactComponent };